module.exports = __webpack_public_path__ + "static/media/male.67ef679c.svg";